import React, { Component, PropTypes } from 'react';
import Icon from './Icon';

export default class Library extends Icon {
  render() {
    let { color, size, viewPortSize, className, ...props } = this.props;

    return (
      <svg
        width={size}
        height={size}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox={'0 0 ' + viewPortSize + ' ' + viewPortSize}
        {...props}
      >
        <g fill={color}>
          <path
            d="M15.7,2.1c-1-0.7-3.3-1.1-4.6-1.1C10,1,8.9,1.3,8,1.8C7.1,1.3,6,1,4.9,1C3.6,1,1.3,1.3,0.3,2.1L0,2.7v11.7
          L1.2,15c0.6-0.4,2.5-0.8,3.7-0.8c1,0,2,0.3,2.7,0.8h0.9c0.7-0.5,1.7-0.8,2.7-0.8c1.2,0,3.1,0.4,3.7,0.8l1.2-0.6V2.7L15.7,2.1z
           M1.5,13.3V3.1c0.8-0.4,2.4-0.6,3.4-0.6c0.9,0,1.7,0.2,2.4,0.6v10.1c-0.7-0.3-1.6-0.4-2.4-0.4C4,12.7,2.6,12.9,1.5,13.3z M14.5,13.3
          c-1.1-0.4-2.5-0.5-3.4-0.5c-0.8,0-1.7,0.2-2.4,0.4V3.1c0.7-0.4,1.5-0.6,2.4-0.6c1,0,2.6,0.3,3.4,0.6V13.3z"
          />
        </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Icons/Library.js